import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import React, { useEffect } from 'react';

import JourneyBuilderDecisionSplitFormContainer from './components/JourneyBuilderDecisionSplitFormContainer';

const styles = {
  main: {
    flexGrow: 1,
    padding: 16,
  },
};

export const JourneyBuilderDecisionSplitComponent = ({
  classes,
  culture,
  currentMID,
  journeyId,
  tokens,
  fetchDecisionSplitObjects,
  fetchDecisionSplitUserData,
  fetchIsHCOEnabled,
  fetchJourneyMetadata,
  fetchLocalization,
}) => {
  useEffect(
    () => {
      const rootMID = window.App.rootBusinessUnitMID;
      if (rootMID && tokens && tokens.fuel2token) {
        fetchDecisionSplitUserData(rootMID, tokens.fuel2token);
      }
    },
    [tokens]
  );

  useEffect(
    () => {
      if (culture) {
        fetchLocalization(culture);
      }
    },
    [culture]
  );

  useEffect(
    () => {
      if (journeyId && currentMID > 0) {
        fetchJourneyMetadata(journeyId, currentMID);
      }
    },
    [journeyId, currentMID]
  );

  useEffect(
    () => {
      if (currentMID > 0) {
        fetchIsHCOEnabled(currentMID);
      }
    },
    [currentMID]
  );

  return (
    <Grid container>
      <Grid item sm={12} className={classes.main}>
        <JourneyBuilderDecisionSplitFormContainer />
      </Grid>
    </Grid>
  );
};
JourneyBuilderDecisionSplitComponent.displayName = 'JourneyBuilderDecisionSplitComponent';

export default withStyles(styles, { name: 'JourneyBuilderComponent' })(
  JourneyBuilderDecisionSplitComponent
);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/JourneyBuilderDecisionSplitComponent.js